export const defaultSelectedSubscriber = () => {
    return {
        license_id: '',
        identification_type: '',
        class_person: '',
        taxpayer_type: '',
        tax_regimen: '',
        company_type: '',
        identification: '',
        check_digit: '',
        name: '',
        short_name: '',
        email: '',
        web_page: '',
        id_legal_representative: '',
        name_legal_representative: '',
        logo: '',
        state: 1,
        type_transfer_utility:'',
        account_utility:'',
        account_lost:'',
        account_results:'',
        manager_wms:null,
        uvt_value: null,
        uvt_electronic_invoice: null,
        configuration: {
            product_digits: '',
            seller_management:0,
            brand_management: 0,
            line_management: 0,
            category_management:0,
            line_description: '',
            subline_description: '',
            category_description: '',
            subcategory_description: '',
            type_description: '',
            recalculate_sales_price: 0,
            percentage_minimum_variation: '',
            rounding_factor: '',
            type_voucher_inventory: '',
            account_entry:'',
            account_exit: '',
            consecutive_product_code: '',
            consecutive_transfer: '',
            consecutive_sales_orders: '',
            consecutive_purchase_orders: '',
            folios_electronic_invoice: '',
            last_date_close: '',
            firm_date: '',
            base_retention_source_products: '',
            percentage_retention_source_products: '',
            base_retention_source_services: '',
            percentage_retention_source_services: '',
            percentage_reteiva: '',
            code_activity_ica: '',
            code_ciiu: '',
            percentage_reteica: '',
            bill_to_pay: '',
            receivable: '',
            account_heritage_utility: '',
            account_heritage_lost: '',
            account_pyg_result_exercise: '',
            monthly_utility_transfer_or_lost: 0,
            annual_utility_transfer_or_lost: 0,
            type_voucher_result_exercise: '',
            first_logo: '',
            year_month_from_util: '',
        },
        branch_office: {
            name:'',
            address:'',
            telephone:'',
            fax:'',
            main:1,
            city_id:'',
            latitude:'',
            length:'',
            branchoffice_type:1,
            city: {
                department_id: ""
            }
        },
        firmDate:null,
        phone:'',
        sender_email:'',
        contact_id:null,
        customer_advance_account_id:null,
        active_collection: null,
        frequency_message: null,
        collection_message: null,
        users_notification_collection: [],
        type_of_business_process:null,
        authorizing_users_reception_docs_ids: [],
        b2c_integration_id: null,
        update_test_database: 0,
        departure_start_date: null,
        wms_json_auth: {
            url: '',
            user: '',
            password: ''
        }
    }

}

export default {
    subscribers: [],
    selectedSubscriber: defaultSelectedSubscriber(),
    error: false,
    errorMessage: '',
    action: 'create',
    check: null,
    accountss: [],
    departments: [],
    cities: [],
    licenses: [],
    fiscalResponsibilitys: [],
    identificationTypes: [],
    companyTypes: [],
    classPersons: [],
    taxpayerTypes: [],
    taxRegimens: [],
    getSubscriberEdit: true,
    parameters:[
        { paramtable_id: 1, tooltip: ''},
        { paramtable_id: 2, tooltip: ''},
        { paramtable_id: 4, tooltip: ''},
        { paramtable_id: 3, tooltip: ''},
        { paramtable_id: 11, tooltip: ''},
    ],
    params: {
        notAux: false,
        onlyAux : false,
        paginate: true,
        page: 1,
        perPage: 1000,
        filter: "",
        sortBy: "id",
        sort: "ASC"
    },
    params_income_account: {
        notAux: false,
        onlyAux : false,
        paginate: true,
        page: 1,
        perPage: 50,
        filter: "",
        sortBy: "id",
        sort: "ASC"
    },
    params_contacts: {
        only_active:true,
        filter: "",
        /*type: "is_customer",*/
        paginate: false
    },
    contacts: [],
    customerAdvanceAccounts: [],
    users: [],
    type_of_business_process:[],
}



// WEBPACK FOOTER //
// ./src/modules/subscribers/state.js